// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import ReactDatepicker from "react-datepicker";
import * as ReactFinalForm from "react-final-form";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";

import ("react-datepicker/dist/react-datepicker.css")
;

var months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

var currentYear = new Date().getFullYear();

var years = Core__Array.fromInitializer(currentYear - 1900 | 0, (function (i) {
        return currentYear - i | 0;
      }));

function DateOfBirth(props) {
  var fieldConfig = props.fieldConfig;
  var path = fieldConfig.confirmRequestWritePath;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var dateFormat = Core__Option.getOr(fieldConfig.inputFormatPattern, "dd-MM-yyyy");
  var match$2 = React.useState(function () {
        return null;
      });
  var setSelectedDate = match$2[1];
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var field = ReactFinalForm.useField(path, {
        validate: validate
      });
  var invalid = field.meta.invalid;
  var showError = field.meta.touched || field.meta.submitFailed;
  return React.createElement("div", {
              className: "flex flex-col gap-1"
            }, React.createElement("div", {
                  className: "Label",
                  style: {
                    fontSize: themeObj.fontSizeLg,
                    fontWeight: themeObj.fontWeightNormal,
                    opacity: "0.6"
                  }
                }, match$1.label), React.createElement(ReactDatepicker, {
                  selected: match$2[0],
                  onChange: (function (date) {
                      setSelectedDate(function (param) {
                            return date;
                          });
                      var strVal = Core__Option.getOr(Core__Option.map((date == null) ? undefined : Caml_option.some(date), (function (d) {
                                  return d.toLocaleDateString("en-CA");
                                })), "");
                      field.input.onChange(strVal);
                    }),
                  onBlur: (function (param) {
                      field.input.onBlur();
                    }),
                  showIcon: true,
                  icon: Caml_option.some(React.createElement(Icon$OrcaPaymentPage.make, {
                            name: "calander",
                            size: 13,
                            className: "!px-[6px] !py-[10px]"
                          })),
                  dateFormat: dateFormat,
                  renderCustomHeader: (function (val) {
                      return React.createElement("div", {
                                  className: "flex gap-4 items-center justify-center m-2"
                                }, React.createElement("select", {
                                      className: "p-1",
                                      value: val.date.getFullYear().toString(),
                                      onChange: (function (ev) {
                                          var value = ev.target.value;
                                          val.changeYear(value);
                                        })
                                    }, years.map(function (option) {
                                          return React.createElement("option", {
                                                      key: option.toString(),
                                                      value: option.toString()
                                                    }, option);
                                        })), React.createElement("select", {
                                      className: "p-1",
                                      value: Core__Option.getOr(months[val.date.getMonth()], "January"),
                                      onChange: (function (ev) {
                                          var value = ev.target.value;
                                          val.changeMonth(months.indexOf(value));
                                        })
                                    }, months.map(function (option) {
                                          return React.createElement("option", {
                                                      key: option,
                                                      value: option
                                                    }, option);
                                        })));
                    }),
                  placeholderText: match$1.placeholder,
                  className: "w-full border border-gray-300 rounded p-2",
                  wrapperClassName: "datepicker",
                  shouldCloseOnSelect: true
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showError && invalid,
                  children: React.createElement("div", {
                        className: "Error pt-1",
                        style: {
                          color: themeObj.colorDangerText,
                          fontSize: themeObj.fontSizeSm,
                          textAlign: "left",
                          alignSelf: "start"
                        }
                      }, Core__Option.getOr(field.meta.error, ""))
                }));
}

var startYear = 1900;

var make = DateOfBirth;

export {
  months ,
  startYear ,
  currentYear ,
  years ,
  make ,
}
/*  Not a pure module */
